module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/babel-runtime/core-js/object/assign.js
// module id = 216
// module chunks = 0